<template>
  <div class="tool-buttons" :class="{ 'btn-none-margin': btnNoneMargin }">
    <div
      v-if="hasSpecialAdd"
      class="tool-button has-hover"
      data-title="新增"
      @click="specialAdd"
    >
      <img :src="specialAddImg" alt="add" />
    </div>
    <div
      v-if="hasAdd"
      class="tool-button has-hover"
      data-title="新增"
      @click="add"
    >
      <img :src="addImg" alt="add" />
    </div>
    <div class="position-relative">
      <div v-if="hasExtraAdd" class="tool-button" @click="extraAdd">
        <img :src="addImg" alt="add" />
      </div>
      <slot name="extra-add"></slot>
    </div>
    <div
      v-if="hasView"
      class="tool-button has-hover"
      data-title="瀏覽"
      @click="onView"
    >
      <img :src="viewImg" alt="view" />
    </div>
    <div
      v-if="hasEdit"
      class="tool-button has-hover"
      data-title="編輯"
      @click="edit"
    >
      <img :src="editImg" alt="edit" />
    </div>
    <div
      v-if="hasRemove"
      class="tool-button has-hover"
      data-title="刪除"
      @click="remove"
    >
      <img :src="removeImg" alt="remove" />
    </div>
    <div
      v-if="hasImage"
      class="tool-button has-hover"
      data-title="圖片"
      @click="onImage"
    >
      <img :src="imageImg" alt="image" />
    </div>
    <div
      v-if="hasCopy"
      class="tool-button has-hover"
      data-title="複製"
      @click="copy"
    >
      <img :src="copyImg" alt="copy" />
    </div>
    <div
      v-if="hasPdf"
      class="tool-button has-hover"
      data-title="PDF"
      @click="downloadPdf"
    >
      <img :src="pdfImg" alt="PDF" />
    </div>
    <div
      v-if="hasExcel"
      class="tool-button has-hover"
      data-title="Excel"
      @click="downloadExcel"
    >
      <img :src="xlsImg" alt="XLS" />
    </div>
    <div
      v-if="hasPrint"
      class="tool-button has-hover"
      data-title="列印"
      @click="onPrint"
    >
      <img :src="printerImg" alt="Printer" />
    </div>
    <div
      v-if="hasCancel"
      class="tool-button has-hover"
      data-title="取消"
      @click="cancel"
    >
      <img :src="cancelImg" alt="cancel" />
    </div>
    <button
      v-if="hasDone && isSubmit"
      class="tool-button has-hover"
      data-title="完成"
      type="submit"
    >
      <img :src="doneImg" alt="done" />
    </button>
    <div
      v-else-if="hasDone && !isSubmit"
      class="tool-button has-hover"
      data-title="完成"
      @click="done"
    >
      <img :src="doneImg" alt="done" />
    </div>
    <div
      v-if="hasSend"
      class="tool-button has-hover"
      data-title="寄送"
      @click="send"
    >
      <img :src="sendImg" alt="send" />
    </div>
    <div
      v-if="hasFile"
      class="tool-button has-hover"
      data-title="資料"
      @click="onFile"
    >
      <img :src="fileImg" alt="file" />
    </div>
    <div
      v-if="hasInvoice"
      class="tool-button has-hover"
      data-title="電子發票"
      @click="invoice"
    >
      <img :src="invoiceImg" alt="invoice" />
    </div>
    <div
      v-if="hasCoin"
      class="tool-button has-hover"
      data-title="批次改價"
      @click="onCoin"
    >
      <img :src="coinImg" alt="coin" />
    </div>
    <div
      v-if="hasBurger"
      class="tool-button has-hover"
      data-title="廠商商品"
      @click="onBurger"
    >
      <img :src="burgerImg" alt="burger" />
    </div>
    <div
      v-if="hasBag"
      class="tool-button has-hover"
      data-title="廠商商品"
      @click="onBag"
    >
      <img :src="bagImg" alt="bag" />
    </div>
    <div
      v-if="hasBefore"
      class="tool-button has-hover"
      data-title="上移"
      @click="onBefore"
    >
      <img :src="beforeImg" alt="before" style="transform: rotate(-90deg)" />
    </div>
    <div
      v-if="hasAfter"
      class="tool-button has-hover"
      data-title="下移"
      @click="onAfter"
    >
      <img :src="afterImg" alt="after" style="transform: rotate(90deg)" />
    </div>
    <div
      v-if="hasSequence"
      class="tool-button has-hover"
      data-title="順序"
      @click="onSequence"
    >
      <img :src="sequenceImg" alt="sequence" />
    </div>
    <div
      v-if="hasSetting"
      class="tool-button has-hover"
      data-title="設定"
      @click.stop="onSetting($event)"
    >
      <img :src="settingImg" alt="setting" />
    </div>
    <div
      v-if="hasSync"
      class="tool-button has-hover"
      data-title="同步"
      @click="onSync"
    >
      <img :src="syncImg" alt="sync" />
    </div>
    <div
      v-if="hasUpload"
      class="tool-button has-hover"
      data-title="同步"
      @click="onUpload"
    >
      <img :src="uploadImg" alt="upload" />
    </div>
    <div
      v-if="hasBalance"
      class="tool-button has-hover"
      data-title="自動沖帳"
      @click="onBalance"
    >
      <img :src="balanceImg" alt="balance" />
    </div>
    <!-- <div
      v-if="hasPurchase"
      class="tool-button has-hover"
      data-title="轉進貨單"
      @click="onTransfer"
    >
      <img :src="transferImg" alt="transfer" />
    </div> -->
    <div
      v-if="hasTransfer"
      class="tool-button has-hover"
      data-title="批次轉調整單"
      @click="onTransfer"
    >
      <img :src="transferImg" alt="transfer" />
    </div>
    <div
      v-if="hasRedo"
      class="tool-button has-hover"
      data-title="重設"
      @click="onRedo"
    >
      <img :src="redoImg" alt="uturn" />
    </div>
    <div
      v-if="hasUturn"
      class="tool-button has-hover"
      data-title="轉拆解單"
      @click="onUturn"
    >
      <img :src="uturnImg" alt="uturn" />
    </div>
    <div
      v-if="hasSpecification"
      class="tool-button has-hover"
      data-title="多規格"
      @click="onSpecification"
    >
      <img :src="specificationImg" alt="specification" />
    </div>
    <div
      v-if="hasSpecificationModule"
      class="tool-button has-hover"
      data-title="規格模組"
      @click="onSpecificationModule"
    >
      <img :src="specificationModuleImg" alt="specificationModule" />
    </div>
    <div
      v-if="hasPurchase"
      class="tool-button has-hover"
      data-title="轉進貨單"
      @click="onPurchase"
    >
      <img :src="purchaseImg" alt="purchase" />
    </div>
    <div
      v-if="hasLabel"
      class="tool-button has-hover"
      data-title="群組"
      @click="onLabel"
    >
      <img :src="labelImg" alt="label" />
    </div>
    <div
      v-if="hasVision"
      class="tool-button has-hover"
      data-title="視力"
      @click="onVision"
    >
      <img :src="visionImg" alt="vision" />
    </div>
    <div
      v-if="hasHistory"
      class="tool-button has-hover"
      data-title="歷史紀錄"
      @click="onHistory"
    >
      <img :src="historyImg" alt="history" />
    </div>
    <div
      v-if="ECPlatformType == 1"
      class="tool-button has-hover showmore"
      data-title="Showmore同步"
      @click="onECPlatform"
    >
      <svg class="svg-inline--fa" viewBox="-32 0 160 170">
        <path
          class="cls-2"
          d="M69.28,1.88L7.1,37.78c-.16,.09-.28,.22-.43,.31-.59,.36-1.15,.76-1.68,1.21-.15,.13-.29,.27-.44,.41-.55,.5-1.05,1.05-1.52,1.64-.08,.11-.15,.21-.23,.32-.31,.42-.65,.81-.91,1.27-3.87,6.71-1.57,15.29,5.13,19.16l41.13,23.75L7.04,109.59c-.33,.19-.61,.45-.92,.66-.27,.18-.53,.36-.79,.57-.5,.4-.95,.82-1.38,1.27-.19,.2-.39,.4-.57,.62-.44,.52-.83,1.07-1.18,1.65-.09,.14-.2,.25-.28,.39-.05,.08-.07,.17-.12,.26-.32,.58-.58,1.19-.81,1.81-.1,.27-.21,.53-.3,.8-.18,.57-.29,1.15-.39,1.74-.06,.32-.13,.64-.16,.96-.06,.56-.05,1.11-.04,1.67,0,.35,0,.69,.03,1.04,.05,.52,.15,1.03,.26,1.55,.08,.39,.15,.77,.26,1.15,.13,.44,.31,.86,.48,1.29,.18,.45,.37,.9,.6,1.34,.07,.13,.11,.28,.18,.41,.13,.23,.31,.4,.45,.62,.29,.45,.59,.88,.94,1.3,.26,.32,.54,.6,.82,.89,.36,.36,.72,.71,1.12,1.04,.33,.27,.68,.51,1.04,.75,.27,.18,.5,.4,.78,.56l62.18,35.9c6.71,3.87,15.29,1.57,19.16-5.13s1.57-15.29-5.13-19.16l-41.17-23.77,41.15-23.76c.22-.13,.39-.29,.6-.43,.43-.28,.85-.57,1.26-.91,.37-.3,.71-.63,1.04-.96,.29-.29,.57-.58,.83-.9,.38-.45,.71-.93,1.02-1.41,.11-.18,.25-.32,.36-.5,.06-.11,.09-.22,.15-.33,.3-.56,.55-1.13,.78-1.73,.1-.27,.22-.54,.3-.82,.19-.61,.32-1.24,.42-1.87,.04-.25,.1-.5,.13-.76,.08-.68,.08-1.37,.05-2.06,0-.2,0-.39-.02-.59-.06-.71-.19-1.41-.35-2.12-.04-.18-.07-.35-.12-.53-.18-.66-.44-1.29-.72-1.93-.1-.22-.18-.44-.29-.65-.11-.22-.18-.46-.3-.67h0c-.22-.37-.5-.68-.74-1.03-.14-.21-.28-.41-.44-.61-.44-.56-.91-1.06-1.42-1.54-.15-.14-.29-.28-.45-.42-.58-.5-1.19-.93-1.84-1.32-.1-.06-.17-.14-.27-.2l-.82-.47h-.02l-40.29-23.27,41.21-23.79c6.71-3.87,9.01-12.45,5.13-19.16-3.87-6.71-12.45-9.01-19.16-5.13Z"
        ></path>
        <path
          class="cls-1"
          d="M48.17,85.86L7.06,109.6c-.34,.19-.61,.45-.92,.66-.27,.18-.53,.36-.79,.57-.5,.4-.95,.82-1.38,1.27-.19,.2-.39,.4-.57,.62-.44,.52-.83,1.07-1.19,1.65-.09,.14-.2,.25-.28,.39-.05,.08-.07,.17-.12,.26-.32,.58-.58,1.19-.81,1.81-.1,.27-.21,.53-.3,.8-.18,.57-.29,1.15-.39,1.74-.06,.32-.13,.64-.16,.96-.06,.56-.05,1.11-.04,1.68,0,.35,0,.69,.03,1.03,.05,.52,.15,1.04,.26,1.55,.08,.39,.15,.77,.26,1.15,.13,.44,.31,.86,.48,1.29,.18,.46,.37,.9,.6,1.34,.07,.13,.11,.28,.18,.41,.13,.23,.31,.4,.45,.62,.29,.45,.59,.88,.93,1.3,.26,.32,.54,.6,.82,.89,.36,.36,.72,.71,1.12,1.04,.33,.27,.68,.51,1.04,.75,.27,.18,.5,.4,.78,.56l40.69,23.5s-26.54-23.67-5.65-35.66l41.15-23.76c.22-.12,.39-.29,.59-.43,.43-.28,.86-.57,1.26-.91,.37-.3,.71-.63,1.04-.96,.29-.29,.57-.58,.83-.9,.38-.45,.71-.93,1.02-1.42,.11-.17,.25-.32,.36-.5,.06-.11,.09-.22,.15-.33,.3-.56,.55-1.14,.78-1.73,.1-.27,.22-.54,.3-.81,.19-.61,.32-1.24,.42-1.88,.04-.25,.1-.5,.13-.75,.08-.68,.08-1.37,.05-2.06,0-.2,0-.39-.02-.58-.06-.71-.19-1.42-.36-2.12-.04-.17-.07-.35-.12-.52-.18-.66-.44-1.3-.72-1.93-.1-.22-.18-.43-.29-.65-.11-.22-.18-.46-.3-.68-.22-.37-.5-.68-.74-1.03-.14-.21-.28-.41-.44-.61-.44-.56-.92-1.06-1.42-1.54-.15-.14-.29-.28-.45-.42-.58-.5-1.2-.93-1.84-1.33-.1-.06-.17-.14-.27-.19l-.81-.47s-.02-.01-.03-.02l-40.29-23.26c-20.22,11.77,6.05,35.89,6.05,35.89Z"
        ></path>
      </svg>
    </div>
    <div
      v-if="ECPlatformType == 2"
      class="tool-button has-hover"
      data-title="Meepshop同步"
      @click="onECPlatform"
    >
      <img :src="meepshopImg" alt="meepshop" />
    </div>
    <div
      v-if="hasDigiwin"
      class="tool-button has-hover"
      data-title="鼎新同步"
      @click="onDigiwin"
    >
      <img :src="DWAPIImg" alt="DWAPI" />
    </div>
    <div
      v-if="hasUp"
      class="tool-button has-hover"
      data-title="上移"
      @click="onUp"
    >
      <img :src="upImg" alt="up" />
    </div>
    <div
      v-if="hasDown"
      class="tool-button has-hover"
      data-title="下移"
      @click="onDown"
    >
      <img :src="downImg" alt="down" />
    </div>
    <div
      v-if="hasImport"
      class="tool-button has-hover"
      data-title="匯入"
      @click="onImport"
    >
      <img :src="importImg" alt="import" />
    </div>
    <div
      v-if="hasExport"
      class="tool-button has-hover"
      data-title="匯出"
      @click="onExport"
    >
      <img :src="exportImg" alt="export" />
    </div>
    <div
      v-if="hasQRcode"
      class="tool-button has-hover"
      data-title="QR碼"
      @click="onQRcode"
    >
      <img :src="QRcodeImg" alt="QRcode" />
    </div>
    <div
      v-if="hasLabelPrint"
      class="tool-button has-hover"
      data-title="標籤列印"
      @click="onLabelPrint"
    >
      <img :src="txtImg" alt="Printer" />
    </div>
    <slot name="custom-buttons"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      specialAddImg: this.$img.get("Tools/SpecialAdd.svg"),
      addImg: this.$img.get("Tools/Add.svg"),
      editImg: this.$img.get("Tools/Edit.svg"),
      removeImg: this.$img.get("Tools/Remove.svg"),
      imageImg: this.$img.get("Tools/Image.svg"),
      copyImg: this.$img.get("Tools/Copy.svg"),
      pdfImg: this.$img.get("Tools/PDF.svg"),
      xlsImg: this.$img.get("Tools/XLS.svg"),
      printerImg: this.$img.get("Tools/Printer.svg"),
      cancelImg: this.$img.get("Tools/Cancel.svg"),
      doneImg: this.$img.get("Tools/Done.svg"),
      sendImg: this.$img.get("Tools/Send.svg"),
      invoiceImg: this.$img.get("Tools/Invoice.svg"),
      importImg: this.$img.get("Tools/Import.svg"),
      exportImg: this.$img.get("Tools/Export.svg"),
      beforeImg: this.$img.get("Tools/Go.svg"),
      afterImg: this.$img.get("Tools/Go.svg"),
      sequenceImg: this.$img.get("Tools/Sequence.svg"),
      coinImg: this.$img.get("Tools/Coin.svg"),
      syncImg: this.$img.get("Tools/Sync.svg"),
      uploadImg: this.$img.get("Tools/Upload.svg"),
      balanceImg: this.$img.get("Tools/Balance.svg"),
      transferImg: this.$img.get("Tools/Transfer.svg"),
      burgerImg: this.$img.get("Tools/Burger.svg"),
      bagImg: this.$img.get("Tools/Bag.svg"),
      redoImg: this.$img.get("Tools/Return.svg"),
      uturnImg: this.$img.get("Tools/Uturn.svg"),
      specificationImg: this.$img.get("Tools/Specification.svg"),
      specificationModuleImg: this.$img.get("Tools/SpecificationModule.svg"),
      upImg: this.$img.get("Tools/Up.svg"),
      downImg: this.$img.get("Tools/Down.svg"),
      labelImg: this.$img.get("Tools/Label.svg"),
      visionImg: this.$img.get("Tools/Glasses.svg"),
      QRcodeImg: this.$img.get("Tools/QRcode.svg"),
      purchaseImg: this.$img.get("Tools/Purchase.svg"),
      DWAPIImg: this.$img.get("Tools/DWAPI.svg"),
      historyImg: this.$img.get("Tools/History.svg"),
      meepshopImg: this.$img.get("Tools/MeepShop.svg"),
      txtImg: this.$img.get("Tools/Txt.svg"),
      viewImg: this.$img.get("Tools/View.svg"),
      settingImg: this.$img.get("Tools/Setting.svg"),
      fileImg: this.$img.get("Tools/File.svg"),
    };
  },
  props: [
    "hasSpecialAdd",
    "hasAdd",
    "hasExtraAdd",
    "hasEdit",
    "hasRemove",
    "hasImage",
    "hasCopy",
    "hasPdf",
    "hasExcel",
    "hasPrint",
    "hasCancel",
    "hasDone",
    "hasSend",
    "hasInvoice",
    "hasImport",
    "hasExport",
    "hasBefore",
    "hasAfter",
    "hasSequence",
    "hasCoin",
    "hasSync",
    "hasUpload",
    "hasBalance",
    "hasTransfer",
    "hasBurger",
    "hasBag",
    "ECPlatformType",
    "isSubmit",
    "hasRedo",
    "hasUturn",
    "hasSpecification",
    "hasSpecificationModule",
    "hasUp",
    "hasDown",
    "hasLabel",
    "hasVision",
    "hasQRcode",
    "hasPurchase",
    "hasDigiwin",
    "hasHistory",
    "hasLabelPrint",
    "hasView",
    "hasSetting",
    "hasFile",
    "btnNoneMargin",
  ],
  emits: [
    "downloadExcel",
    "downloadPdf",
    "onAdd",
    "onAfter",
    "onBag",
    "onBalance",
    "onBefore",
    "onBurger",
    "onCancel",
    "onCoin",
    "onCopy",
    "onDigiwin",
    "onDone",
    "onECPlatform",
    "onEdit",
    "onExport",
    "onExtraAdd",
    "onFile",
    "onHistory",
    "onImage",
    "onImport",
    "onInvoice",
    "onLabel",
    "onLabelPrint",
    "onPrint",
    "onPurchase",
    "onQRcode",
    "onRedo",
    "onRemove",
    "onSend",
    "onSequence",
    "onSetting",
    "onSpecialAdd",
    "onSpecification",
    "onSpecificationModule",
    "onSync",
    "onTransfer",
    "onTurn",
    "onUpload",
    "onUturn",
    "onView",
    "onVision",
  ],
  methods: {
    specialAdd() {
      this.$emit("onSpecialAdd");
    },
    add() {
      this.$emit("onAdd");
    },
    extraAdd() {
      this.$emit("onExtraAdd");
    },
    edit() {
      this.$emit("onEdit");
    },
    remove() {
      this.$func
        .message({
          type: "confirm",
          mainMessage: "確定刪除？",
        })
        .then((result) => {
          if (result) {
            this.$emit("onRemove");
          }
        });
    },
    onImage() {
      this.$emit("onImage");
    },
    copy() {
      this.$emit("onCopy");
    },
    downloadPdf() {
      this.$emit("downloadPdf");
    },
    downloadExcel() {
      this.$emit("downloadExcel");
    },
    onPrint() {
      this.$emit("onPrint");
    },
    cancel() {
      // this.$func
      //   .message({
      //     type: "confirm",
      //     mainMessage: "變更尚未儲存，確定離開嗎？",
      //   })
      //   .then((result) => {
      //     if (result) {
      this.$emit("onCancel");
      //   }
      // });
    },
    done() {
      // this.$func
      //   .message({
      //     type: "confirm",
      //     mainMessage: "確定儲存變更嗎？",
      //   })
      //   .then((result) => {
      //     if (result) {
      this.$emit("onDone");
      //   }
      // });
    },
    send() {
      this.$emit("onSend");
    },
    onFile() {
      this.$emit("onFile");
    },
    invoice() {
      this.$emit("onInvoice");
    },
    onImport() {
      this.$emit("onImport");
    },
    onExport() {
      this.$emit("onExport");
    },
    onTurn() {
      this.$emit("onTurn");
    },
    onBefore() {
      this.$emit("onBefore");
    },
    onAfter() {
      this.$emit("onAfter");
    },
    onSequence() {
      this.$emit("onSequence");
    },
    onCoin() {
      this.$emit("onCoin");
    },
    onUpload() {
      this.$emit("onUpload");
    },
    onSync() {
      this.$emit("onSync");
    },
    onBalance() {
      this.$emit("onBalance");
    },
    onTransfer() {
      this.$emit("onTransfer");
    },
    onBurger() {
      this.$emit("onBurger");
    },
    onBag() {
      this.$emit("onBag");
    },
    onRedo() {
      this.$emit("onRedo");
    },
    onUturn() {
      this.$emit("onUturn");
    },
    onSpecification() {
      this.$emit("onSpecification");
    },
    onSpecificationModule() {
      this.$emit("onSpecificationModule");
    },
    onECPlatform() {
      this.$emit("onECPlatform");
    },
    onLabel() {
      this.$emit("onLabel");
    },
    onVision() {
      this.$emit("onVision");
    },
    onQRcode() {
      this.$emit("onQRcode");
    },
    onPurchase() {
      this.$emit("onPurchase");
    },
    onDigiwin() {
      this.$emit("onDigiwin");
    },
    onHistory() {
      this.$emit("onHistory");
    },
    onLabelPrint() {
      this.$emit("onLabelPrint");
    },
    onView() {
      this.$emit("onView");
    },
    onSetting(event) {
      this.$emit("onSetting", event);
    },
  },
};
</script>

<style lang="scss">
.tool-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 24px 2px 10px;
  &.btn-none-margin {
    margin-left: 10px !important;
    .tool-button {
      margin: 0;
    }
  }
  @media screen and (max-width: 575px) {
    // width: 100%;
    margin: 10px 0 0;
  }
}
.tool-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  transition: all 0.3s;
  z-index: 12;
  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
    filter: brightness(1.1);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 5px;
  }
}
.tool-button.legacy-text-tool {
  width: auto;
  min-width: 30px;
  padding: 0 5px;
  color: #4695c9;
  font-weight: 600;
}
.cls-1 {
  fill: #e6725e;
}
.cls-2 {
  fill: #26b8d6;
}
.showmore {
  svg {
    width: 20px;
  }
}
button {
  border: none;
  background-color: transparent;
}
.has-hover::after {
  content: attr(data-title);
  position: absolute;
  top: 32px;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 300;
  white-space: nowrap;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;
}

.has-hover:hover::after {
  opacity: 1;
}
</style>
